export default __webpack_public_path__ + "static/media/DefinixIcon-12.bf1e8134.png";